module.exports = __webpack_public_path__ + "media/images/nav-logo_bizjumping-540aeabd10cb30291bb0f244973e95fe.png";